<a class="application-item ct-card interactive" [routerLink]="['/applications']">
  <div class="details">
    <div class="title-row">
      <b class="title">{{ application().jobTitle }}</b>
      <ct-lib-tag [variant]="statusTagVariant()">
        {{ dashboard.statusTranslationKey(application().status) | transloco }}
      </ct-lib-tag>
    </div>
    <span class="company text-muted">{{ application().companyName }}</span>
  </div>
  <span class="application-link">
    {{ 'jobboard.platform.dashboard.applications.open' | transloco }}
    <fa-icon [icon]="icons.chevronRight" aria-hidden="true"></fa-icon>
  </span>
</a>
